export const isNumber = (value) => /^[0-9]*$/g.test(value);

export const isEnglishName = (value) => /^[A-Z ]*$/g.test(value);

export const getIndexFromSameTag = (parentElement, targetElement) => {
  const targetTagName = targetElement.tagName;
  const sameTagElementList = Object.values(parentElement.children).filter(
    (element) => element.tagName === targetTagName,
  );

  return sameTagElementList.indexOf(targetElement) + 1;
};

export const setFocusSameTagByIndex = (currentElement, targetIndex) => {
  const { parentElement } = currentElement;
  const targetElement = parentElement.querySelector(
    `${currentElement.tagName}:nth-child(${targetIndex})`,
  );

  if (!targetElement) return false;

  targetElement.focus();
  return true;
};

export const getUuid = () =>
  ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
  );
